import { combineReducers } from 'redux';
import { TRouter } from '../../../../../shared/frontend/libs/router/types';
import { reducer as groupCharterReducer } from '../../../../../shared/frontend/scripts/actions/groupCharter';
import { eventHubReducer } from '../../../../../shared/frontend/scripts/event-hub/store/modules';
import { reducer as eventsManagementReducer } from '../../../../../shared/frontend/scripts/event-management/store/modules';
import { reducer as eventTeamsReducer } from '../../../../../shared/frontend/scripts/eventTeams/modules';
import { reducer as eventDetailsReducer } from '../../../../../shared/frontend/scripts/events/store/details/modules';
import { reducer as eventsReducer } from '../../../../../shared/frontend/scripts/events/store/list/modules';
import autocompleteReducer from '../../../../../shared/frontend/scripts/global-search/autocomplete/store/modules'; // should be rio-component
import globalSearchReducer from '../../../../../shared/frontend/scripts/global-search/store/modules';
import { reducer as messageCenterReducer } from '../../../../../shared/frontend/scripts/messageCenter/modules';
import pushNotificationReducer from '../../../../../shared/frontend/scripts/reducers/pushNotificationReducer';
import userSettingsReducer from '../../../../../shared/frontend/scripts/reducers/userSettingsReducer';
import sidebarContentReducer from '../../../../../shared/frontend/scripts/sidebar/store/sidebarContentReducer';
import { reducer as threadReducer } from '../../../../../shared/frontend/scripts/thread/store/modules';
import applicationReducer from '../applicationsManagement/modules';
import characterRecruitmenPageReducer from '../character/modules';
import { reducer as eventStandingsReducer } from '../eventStandings/modules';
import guildRecruitmenPageReducer from '../guild/modules';
import { reducer as inReviewReducer } from '../in-review/modules';
import { GROUP_COMPOSITION_COMPARE_STATE_KEY, groupCompositionCompareModule } from '../raiding/store/modules';
import createRecruitmentProfileReducer from '../recruitmentProfiles/modules';
import characterRecruitmentSettingsReducer from '../recruitmentSettings/modules';
import { reducer as replaysManagementReducer } from '../replaysManagement/modules';
import globalRecruitmentProfileReducer from '../shared/recruitment/components/RecruitmentProfilePreview/modules';
import recruitmentReducer from '../shared/recruitment/modules';
import { reducer as statisticsReducer } from '../statistics/store/modules';
import { reducer as teamReducer } from '../team/modules';
import { reducer as siteModerationReducer } from '../siteModeration/store/modules';
import { reducer as timelineEventManagementReducer } from '../timelineEventManagement/store/modules';
import { timelineEventsApi } from '../services/api/timelineEventsApi';
import { reducer as userReducer } from '../user/modules';
import { charactersApi } from '../services/api/charactersApi';
import { projectMetadataApi } from '../services/api/projectMetadataApi';
import { specLoadoutTalentRunsApi } from '../services/api/specLoadoutTalentRunsApi';
import { specStatisticsApi } from '../specs/api/specStatisticsApi';
import { talentDifferencesSlice } from '../specs/metrics/talents/store/talentDifferencesSlice';
import addGuildReducer from './addGuildReducer';
import authReducer from './authReducer';
import bossRankingsReducer from './bossRankingsReducer';
import characterDetailsReducer from './characterDetailsReducer';
import characterHistoryReducer from './characterHistoryReducer';
import characterMythicPlusProgressReducer from './characterMythicPlusProgressReducer';
import characterMythicPlusRunsReducer from './characterMythicPlusRunsReducer';
import characterRaidProgressReducer from './characterRaidProgressReducer';
import characterRaidRankingReducer from './characterRaidRankingReducer';
import collegiateDungeonRaceReducer from './collegiateDungeonRaceReducer';
import connectedRealmSearchReducer from './connectedRealmSearchReducer';
import embeddedPlayerStreamReducer from './embeddedPlayerStreamReducer';
import errorReducer from './errorReducer';
import eventRegistrationReducer from './eventRegistrationReducer';
import featuredStreamersReducer from './featuredStreamersReducer';
import guildDetailsReducer from './guildDetailsReducer';
import guildRankingsTableReducer from './guildRankingsTableReducer';
import guildRosterReducer from './guildRosterReducer';
import keystoneCharacterRankingsReducer from './keystoneCharacterRankingsReducer';
import keystoneDungeonStatsReducer from './keystoneDungeonStatsReducer';
import keystoneEventReducer from './keystoneEventReducer';
import keystoneLoggedRunTournamentReducer from './keystoneLoggedRunTournamentReducer';
import keystoneRankingsReducer from './keystoneRankingsReducer';
import keystoneRunAggregatesReducer from './keystoneRunAggregatesReducer';
import keystoneRunsReducer from './keystoneRunsReducer';
import keystoneTeamDetailsReducer from './keystoneTeamDetailsReducer';
import keystoneTeamRankingsReducer from './keystoneTeamRankingsReducer';
import keystoneTeamReducer from './keystoneTeamReducer';
import keystoneTeamRunsReducer from './keystoneTeamRunsReducer';
import keystoneWarbandRankingsReducer from './keystoneWarbandRankingsReducer';
import { reducer as localeConfigReducer } from './localeConfigReducer';
import mdiStandingsReducer from './mdiStandingsReducer';
import mythicDungeonInvitationalReducer from './mythicDungeonInvitationalReducer';
import mythicPlusCutoffsReducer from './mythicPlusCutoffsReducer';
import newsArticleReducer from './newsArticleReducer';
import newsListReducer from './newsListReducer';
import progressRankingsReducer from './progressRankingsReducer';
import queueModalReducer from './queueModalReducer';
import raceProgressReducer from './raceProgressReducer';
import raceVisualizerReducer from './raceVisualizerReducer';
import raidLoggedEncounterReducer from './raidLoggedEncounterReducer';
import raidRankingsReducer from './raidRankingsReducer';
import realmListingReducer from './realmListingReducer';
import realmSearchReducer from './realmSearchReducer';
import rosterHistoryReducer from './rosterHistoryReducer';
import siteMetaReducer from './siteMetaReducer';
import teamNameGeneratorReducer from './teamNameGeneratorReducer';
import worldFirstTrackerReducer from './worldFirstTrackerReducer';
import { connectRouter } from '../../../../../shared/frontend/libs/router/redux-store';

export default function createRootReducer(router: TRouter) {
  return combineReducers({
    auth: authReducer,
    realmListing: realmListingReducer,
    connectedRealm: connectedRealmSearchReducer,
    rankingsTable: guildRankingsTableReducer,
    siteMeta: siteMetaReducer,
    bossRankings: bossRankingsReducer,
    progressRankings: progressRankingsReducer,
    raidRankings: raidRankingsReducer,
    raceProgress: raceProgressReducer,
    guildDetails: guildDetailsReducer,
    guildRoster: guildRosterReducer,
    rosterHistory: rosterHistoryReducer,
    characterDetails: characterDetailsReducer,
    characterHistory: characterHistoryReducer,
    keystoneRuns: keystoneRunsReducer,
    keystoneLoggedRunTournament: keystoneLoggedRunTournamentReducer,
    raidLoggedEncounter: raidLoggedEncounterReducer,
    keystoneRunAggregates: keystoneRunAggregatesReducer,
    keystoneRankings: keystoneRankingsReducer,
    realmSearch: realmSearchReducer,
    sidebarContent: sidebarContentReducer,
    characterRaidProgress: characterRaidProgressReducer,
    characterRaidRanking: characterRaidRankingReducer,
    characterMythicPlusProgress: characterMythicPlusProgressReducer,
    characterMythicPlusRuns: characterMythicPlusRunsReducer,
    keystoneCharacterRankings: keystoneCharacterRankingsReducer,
    keystoneWarbandRankings: keystoneWarbandRankingsReducer,
    keystoneTeamRankings: keystoneTeamRankingsReducer,
    keystoneTeamDetails: keystoneTeamDetailsReducer,
    keystoneTeamHistory: keystoneTeamReducer,
    keystoneTeamRuns: keystoneTeamRunsReducer,
    userSettings: userSettingsReducer,
    pushNotification: pushNotificationReducer,
    eventRegistration: eventRegistrationReducer,
    error: errorReducer,
    queueModal: queueModalReducer,
    addGuild: addGuildReducer,
    mythicDungeonInvitational: mythicDungeonInvitationalReducer,
    mdiStandings: mdiStandingsReducer,
    collegiateDungeonRace: collegiateDungeonRaceReducer,
    keystoneDungeonStats: keystoneDungeonStatsReducer,
    keystoneEvent: keystoneEventReducer,
    globalSearch: globalSearchReducer,
    autoComplete: autocompleteReducer,
    newsArticle: newsArticleReducer,
    newsList: newsListReducer,
    embeddedPlayerStream: embeddedPlayerStreamReducer,
    worldFirstTracker: worldFirstTrackerReducer,
    raceVisualizer: raceVisualizerReducer,
    featuredStreamers: featuredStreamersReducer,
    teamNameGenerator: teamNameGeneratorReducer,
    inReview: inReviewReducer,
    groupCharter: groupCharterReducer,
    messageCenter: messageCenterReducer,
    user: userReducer,
    team: teamReducer,
    thread: threadReducer,
    mythicPlusCutoffs: mythicPlusCutoffsReducer,
    config: (state = {}) => state,
    siteConfig: (state = {}) => state,
    localeConfig: localeConfigReducer,
    currentFeatures: (state = {}) => state,
    consentManagementEnabled: (state = {}) => state,
    isLoggedIn: (state = {}) => state,
    router: connectRouter(router),

    // recruitment profile creation
    createRecruitmentProfile: createRecruitmentProfileReducer,

    // recruitment settings page
    characterRecruitmentSettings: characterRecruitmentSettingsReducer,

    // character recruitment profiles page
    characterRecruitment: characterRecruitmenPageReducer,

    // guild recruitment profiles page
    guildRecruitment: guildRecruitmenPageReducer,

    // global recruitment profile state
    globalRecruitmentProfiles: globalRecruitmentProfileReducer,

    applicationsManagement: applicationReducer,

    // global shared recruitment
    recruitment: recruitmentReducer,

    replaysManagement: replaysManagementReducer,

    // events
    eventsManagement: eventsManagementReducer,
    eventDetails: eventDetailsReducer,
    eventStandings: eventStandingsReducer,
    eventTeams: eventTeamsReducer,
    events: eventsReducer,
    eventHub: eventHubReducer,

    // statistics
    statistics: statisticsReducer,

    // site moderation
    siteModeration: siteModerationReducer,

    // timeline event management
    timelineEventManagement: timelineEventManagementReducer,

    // timeline events (RTK Query)
    [timelineEventsApi.reducerPath]: timelineEventsApi.reducer,

    // group composition compare
    [GROUP_COMPOSITION_COMPARE_STATE_KEY]: groupCompositionCompareModule.reducer,

    // Talent UI slices
    talentDifferences: talentDifferencesSlice.reducer,

    // RTK Query APIs
    [specLoadoutTalentRunsApi.reducerPath]: specLoadoutTalentRunsApi.reducer,
    [specStatisticsApi.reducerPath]: specStatisticsApi.reducer,
    [projectMetadataApi.reducerPath]: projectMetadataApi.reducer,
    [charactersApi.reducerPath]: charactersApi.reducer
  } as any);
}

// Centralized RTK Query API registration — add new APIs here
const rtkQueryApis = [
  specLoadoutTalentRunsApi,
  specStatisticsApi,
  timelineEventsApi,
  projectMetadataApi,
  charactersApi
];
export const apiMiddlewares = rtkQueryApis.map((api) => api.middleware);
